import { render } from "./PricingMatrix.vue?vue&type=template&id=4cccb978&scoped=true"
import script from "./PricingMatrix.vue?vue&type=script&lang=js"
export * from "./PricingMatrix.vue?vue&type=script&lang=js"

import "./PricingMatrix.vue?vue&type=style&index=0&id=4cccb978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cccb978"]])

export default __exports__